import BaseComponent from 'scripts/BaseComponent.js';

export default class Inview extends BaseComponent {
  constructor(component) {
    super(component);

    this.debug = false;

    this.refs = {
      entry: '.js-inview-entry',
      inviewClass: 'is-inview',
      noTransitionsClass: 'no-transitions',
      html: 'html',
    };

    this.dom = {
      $component: component,
      $entries: this.$getAll(this.refs.entry),
      $html: document.querySelector(this.refs.html),
    };

    this.state = {
      observer: null,
      observerConfig: {
        rootMargin: '-10% 0%',
        threshold: 0.3,
      },
    };

    this.mount();

    this.init();
  }

  mount() {
    // console.log('Inview : mount', this);
    const { dom } = this;
    window.addEventListener('DOMContentLoaded', () => {
      dom.$html.classList.remove(this.refs.noTransitionsClass);
    });
  }

  init() {
    this.observe();
  }

  observe() {
    const { state, dom } = this;
    // console.log('Inview : observe', this);

    state.observer = new IntersectionObserver(this.onIntersection.bind(this), state.observerConfig);
    dom.$entries.forEach(($el) => state.observer.observe($el));
  }

  onIntersection(entries) {
    const { refs, state } = this;
    // console.log('Inview : onIntersection', this);

    const inviewEntries = entries.filter((entry) => entry.intersectionRatio > 0);
    inviewEntries.forEach((entry) => {
      state.observer.unobserve(entry.target);
      entry.target.classList.add(refs.inviewClass);
    });
  }
}
